import { checkAccessForList } from 'modules/common/utils';
import { ControlLabel, Wrapper } from 'modules/theme';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { globalStateSelector } from 'store/selector';
import { injectGlobal } from 'styled-components';
import { Box, BoxName, Row, RowTitle } from '../styles/main';
import SettingDropdownMenu from './SettingDropdownMenu';

injectGlobal`
@media only screen and (max-width: 767px) {
    .for-background{
      display:none;
    }
    .boxsmall-title{
      font-size: 15px !important;
    }
    .admin-label{
      margin-top:20%;
    }
}
`;

class MenuListing extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Display: 'none',
			UserOptionDisplay: 'none',
			UserArrow: 'keyboard_double_arrow_down',
			Arrow: 'keyboard_double_arrow_down',
		};
	}

	renderChildren(el) {
		// return (
		// 	el.childs &&
		// 	el.childs.map((cl) => {
		// 		return this.renderBox(cl.name, cl.font, cl.link);
		// 	})
		// );
		return el.childs &&
		el.childs.map((cl) => {
			if ("font" in cl) {
				return this.renderBox(cl.name, cl.font, cl.link);
			}
			return this.renderIconBox(cl.name, cl.img, cl.link);
		})
	}

	renderIconBox(name, image, to, block) {
		const { __ } = this.context;
		return (
			<Box>
				<Link
					style={!block ? {} : { cursor: 'not-allowed' }}
					to={!block ? to : '#'}
				>
					{image}
					<BoxName>{__(name)}</BoxName>
				</Link>
			</Box>
		);
	}

	renderBox(name, image, to, block) {
		const { __ } = this.context;
		return (
			<Box>
				<Link
					style={!block ? {} : { cursor: 'not-allowed' }}
					to={!block ? to : '#'}
				>
					<span class='material-symbols-outlined setting-icon'>{image}</span>
					<BoxName>{__(name)}</BoxName>
				</Link>
			</Box>
		);
	}

	renderMenu(list) {
		const { __ } = this.context;
		list = checkAccessForList(this.props.accessDefination, list);
		let menu = list.map((el) => (
			<Row className='rowBox'>
				<Col sm={12}>
					<RowTitle className='secondRow boxsmall-title'>
						{__(el.name)}
					</RowTitle>
					<div className='d-flex w-100'>
						<div>{this.renderChildren(el)}</div>
					</div>
				</Col>
			</Row>
		));

		if (menu.length) {
			return menu;
		} else {
			return <React.Fragment />;
		}
	}
	render() {
		const { __ } = this.context;
		const { list, menuName } = this.props;
		const content = <div>{this.renderMenu(list)}</div>;

		return (
			<Wrapper
				showLeftSideBar={true}
				leftSidebar={<SettingDropdownMenu name='Message' list={list} />}
				header={<Wrapper.Header />}
				heading={<ControlLabel>{menuName}</ControlLabel>}
				actionBar={false}
				content={content}
				transparent={false}
			/>
		);
	}
}

MenuListing.contextTypes = {
	__: PropTypes.func,
};

const stateToProps = (state) => ({
	accessDefination: globalStateSelector.getDynamic(state, {
		key: 'accessDefination',
	}),
});

export default connect(stateToProps)(MenuListing);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/MenuListing.js